import { render, staticRenderFns } from "./OpenQuestion.vue?vue&type=template&id=ce54d87c&scoped=true&"
import script from "./OpenQuestion.vue?vue&type=script&lang=js&"
export * from "./OpenQuestion.vue?vue&type=script&lang=js&"
import style0 from "./OpenQuestion.vue?vue&type=style&index=0&id=ce54d87c&scoped=true&lang=css&"
import style1 from "./OpenQuestion.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce54d87c",
  null
  
)

export default component.exports